import { VIEW_TYPES } from "@/other/constants/OtherKeys";
import type { PageGuideDefinition } from "../types";

/** Target ids for Kanban card fields — use with `guideTargetProps()` or `data-guide`. */
export const KANBAN_CARD_FIELDS_GUIDE_TARGETS = {
  openButton: "kanban-card-fields-open",
  visibleSection: "kanban-card-fields-visible",
  availableSection: "kanban-card-fields-available",
  preview: "kanban-card-fields-preview",
  actions: "kanban-card-fields-actions",
} as const;

export const kanbanCardFieldsEntryGuide: PageGuideDefinition = {
  id: "kanban-card-fields-entry-v1",
  viewType: VIEW_TYPES.tasks,
  steps: [
    {
      target: KANBAN_CARD_FIELDS_GUIDE_TARGETS.openButton,
      placement: { side: "bottom", align: "end" },
      title: "Customize card fields",
      body: "Open this editor from Kanban view to choose which optional fields appear on every card in your board.",
    },
  ],
};

export const kanbanCardFieldsEditorGuide: PageGuideDefinition = {
  id: "kanban-card-fields-editor-v1",
  viewType: VIEW_TYPES.tasks,
  steps: [
    {
      target: KANBAN_CARD_FIELDS_GUIDE_TARGETS.visibleSection,
      placement: { side: "right", align: "start" },
      title: "Fields on your cards",
      body: "Name always stays at the top. Add optional fields here, drag to reorder, or use − to remove one and free a slot.",
    },
    {
      target: KANBAN_CARD_FIELDS_GUIDE_TARGETS.availableSection,
      placement: { side: "right", align: "start" },
      title: "Add more fields",
      body: "Browse fields by category. Click + to move a field into the visible list when you have room.",
    },
    {
      target: KANBAN_CARD_FIELDS_GUIDE_TARGETS.preview,
      placement: { side: "left", align: "center" },
      title: "Live preview",
      body: "See how a card will look with your current field selection before you save.",
    },
    {
      target: KANBAN_CARD_FIELDS_GUIDE_TARGETS.actions,
      placement: { side: "bottom", align: "end" },
      title: "Save your layout",
      body: "Save changes to apply them to every card on this board, or reset to restore the default field set.",
    },
  ],
};
